// extracted by mini-css-extract-plugin
export default {"normal":"CustomButton_normal__123zD","active":"CustomButton_active__HUlfl"};